
import { defineComponent } from "vue";
import colors from "@/styles/colors";
import RoundButton from "@/components/buttons/RoundButton.vue";

export default defineComponent({
    name: "ValidateRecordButton",
    components: {
        RoundButton
    },
    data() {
        return {
            colors
        };
    }
});
